import React from 'react';

const ContentContext = React.createContext({
  content: {},
});

export default ContentContext;
